import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Stripe Checkout cancel-return page. The seat stays reserved as
// pending_payment; the user can retry from My enrollments ("Pay now") until
// the stale-pending cron or session expiry releases it.

export function PaymentCancelPage() {
  const { t } = useTranslation()
  return (
    <main className="container">
      <h1>{t('payments.cancel_title')}</h1>
      <p>{t('payments.cancel_body')}</p>
      <p><Link to="/me/enrollments">{t('payments.go_enrollments')}</Link></p>
    </main>
  )
}
